import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

const categoryImages: Record<string, string> = {
  "cat-nav-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20design%20for%20navigation%20category%2C%20compass%20inspired%20geometric%20shapes%20with%20amber%20and%20terracotta%20accents%2C%20clean%20composition%20on%20light%20cream%20background%2C%20subtle%20texture%2C%20professional%20modern%20style&width=200&height=200&seq=cat-nav-01&orientation=squarish",
  "cat-reg-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20for%20registration%20category%2C%20person%20silhouette%20with%20geometric%20elements%2C%20soft%20terracotta%20and%20cream%20colors%2C%20clean%20background%2C%20professional%20style&width=200&height=200&seq=cat-reg-01&orientation=squarish",
  "cat-guide-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20for%20guide%20category%2C%20open%20book%20with%20geometric%20shapes%2C%20amber%20and%20cream%20color%20palette%2C%20clean%20composition%20on%20light%20background%2C%20modern%20professional%20style&width=200&height=200&seq=cat-guide-01&orientation=squarish",
  "cat-faq-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20for%20FAQ%20category%2C%20question%20mark%20with%20geometric%20elements%2C%20soft%20terracotta%20and%20cream%20colors%2C%20clean%20light%20background%2C%20modern%20professional%20design&width=200&height=200&seq=cat-faq-01&orientation=squarish",
  "cat-news-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20for%20news%20category%2C%20lightning%20bolt%20with%20geometric%20shapes%2C%20amber%20and%20cream%20color%20palette%2C%20clean%20composition%20on%20light%20background%2C%20modern%20design&width=200&height=200&seq=cat-news-01&orientation=squarish",
  "cat-sec-01": "https://readdy.ai/api/search-image?query=A%20minimalist%20warm%20toned%20abstract%20icon%20for%20security%20category%2C%20shield%20shape%20with%20geometric%20elements%2C%20terracotta%20and%20cream%20colors%2C%20clean%20light%20background%2C%20professional%20modern%20style&width=200&height=200&seq=cat-sec-01&orientation=squarish",
};

export default function FeaturedCategories() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            浏览不同分类的文章和指南，找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={categoryImages[cat.imageSeq] || categoryImages["cat-nav-01"]}
                  alt={cat.name}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                  {cat.articleCount} 篇文章 →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}